import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/img/chat/chatRequest_on.svg'


const _hoisted_1 = { class: "widePage hasHeader" }
const _hoisted_2 = { class: "writerContainer" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_chat_header = _resolveComponent("chat-header")!
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_textarea_autosize = _resolveComponent("textarea-autosize")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_chat_header, {
      hasUserInfo: true,
      hasOptions: false,
      onOpenDetail: _ctx.openDetail,
      userIdentifier: _ctx.$route.params.userIdentifier,
      userName: _ctx.$store.state.selectedUser.name
    }, null, 8, ["onOpenDetail", "userIdentifier", "userName"]),
    _createVNode(_component_localized_text, {
      localizedKey: "app_scriviunmessaggio",
      text: "Scrivi un messaggio",
      class: "fs_14 grey d-block text-center mt-3"
    }),
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_textarea_autosize, {
        placeholder: _ctx.placeholder,
        modelValue: _ctx.vm.firstMessageText,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.vm.firstMessageText = $event)),
        "max-height": 80
      }, null, 8, ["placeholder", "modelValue"]),
      _createVNode("div", {
        class: "squareButton ms-2",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.send()))
      }, [
        _hoisted_3
      ])
    ])
  ]))
}